// extracted by mini-css-extract-plugin
export default {"container":"import_container__c6ofc","Route":"import_Route__YFpyV","uploadButton":"import_uploadButton__ru0N2","drag":"import_drag__jwfl2","spinner":"import_spinner__VH939"};